import { useState } from 'react';
import {
  IconButton,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';

import { CustomerDocumentType, ListResponse } from '@/types';
import { Pagination } from '@/components';
import theme from '@/theme';
import { EditFlat, TrashFlat } from '@/assets/icons';

import { DeleteCustomerDocumentType, UpdateCustomerDocumentType } from '../components';

export interface CustomerDocumentTypeListProps {
  list?: ListResponse<CustomerDocumentType>;
  page: number;
  onChangePage(page: number): void;
}

const CustomerDocumentTypesTable: React.FC<CustomerDocumentTypeListProps> = ({ list, page, onChangePage }) => {
  const [updateModalOpened, setOpenedUpdateModal] = useState(false);
  const [deleteModalOpened, setOpenedDeleteModal] = useState(false);
  const [currentCustomerDocumentType, setCurrentCustomerDocumentType] = useState<CustomerDocumentType | null>(null);

  function openUpdateModal(customerDocumentType: CustomerDocumentType) {
    setCurrentCustomerDocumentType(customerDocumentType);
    setOpenedUpdateModal(true);
  }

  function openDeleteModal(customerDocumentType: CustomerDocumentType) {
    setCurrentCustomerDocumentType(customerDocumentType);
    setOpenedDeleteModal(true);
  }

  return (
    <>
      <Stack spacing={3}>
        <TableContainer component={Paper} sx={{ maxHeight: `calc(100vh - ${theme.spacing(34.5)})` }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Наименование</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>

            <TableBody>
              {list?.data.map((customerDocumentType) => {
                const { name, id } = customerDocumentType;

                return (
                  <TableRow key={id}>
                    <TableCell>{name}</TableCell>

                    <TableCell>
                      <Stack direction="row" spacing={1}>
                        <Tooltip title="Обновить">
                          <IconButton aria-label="Обновить" onClick={() => openUpdateModal(customerDocumentType)}>
                            <EditFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title="Удалить">
                          <IconButton aria-label="Удалить" onClick={() => openDeleteModal(customerDocumentType)}>
                            <TrashFlat sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>

        <Pagination
          size="medium"
          count={list?.meta.last_page}
          page={page}
          boundaryCount={2}
          color="primary"
          shape="rounded"
          onChange={(event, value) => onChangePage(value)}
        />
      </Stack>

      <UpdateCustomerDocumentType
        customerDocumentType={currentCustomerDocumentType!}
        open={updateModalOpened}
        onClose={() => setOpenedUpdateModal(false)}
      />
      <DeleteCustomerDocumentType
        customerDocumentType={currentCustomerDocumentType!}
        open={deleteModalOpened}
        onClose={() => setOpenedDeleteModal(false)}
      />
    </>
  );
};

export default CustomerDocumentTypesTable;
